import { jsx as _jsx_1 } from "@emotion/react/jsx-runtime";
import { ClassNames, css as emoCss } from '@emotion/react';
import { border } from '@guardian/src-foundations/palette';
import { from } from '@guardian/src-foundations/mq';
import { center } from '@root/src/web/lib/center';
// @ts-ignore-start
import { jsx as _jsx } from 'react/jsx-runtime';
// @ts-ignore-end
const padding = emoCss `
	padding: 0 10px;

	${from.mobileLandscape} {
		padding: 0 20px;
	}
`;
const adStyles = emoCss `
	& .ad-slot.ad-slot--collapse {
		display: none;
	}
`;
const sideBorders = (colour) => emoCss `
	${from.tablet} {
		border-left: 1px solid ${colour};
		border-right: 1px solid ${colour};
	}
`;
const topBorder = (colour) => emoCss `
	border-top: 1px solid ${colour};
`;
const setBackgroundColour = (colour) => emoCss `
	background-color: ${colour};
`;
export const ElementContainer = ({ sectionId, showSideBorders = true, showTopBorder = true, padded = true, borderColour = border.secondary, backgroundColour, shouldCenter = true, children, element = 'div', }) => (_jsx_1(ClassNames, { children: ({ css }) => {
        const child = (_jsx_1("div", Object.assign({ id: sectionId, css: [
                shouldCenter && center,
                showSideBorders && sideBorders(borderColour),
                showTopBorder && topBorder(borderColour),
                padded && padding,
            ] }, { children: children && children }), void 0));
        const style = css `
				${adStyles}
				${backgroundColour && setBackgroundColour(backgroundColour)}
			`;
        // Create a react element from the tagName passed in OR
        // default to <div>
        return _jsx(`${element}`, {
            className: style,
            children: child,
        });
    } }, void 0));
